export default "__VITE_ASSET__C662YuJF__"